import {
  CurrentUserService,
  ViewsService,
  FieldsService,
  ContentTypesService,
  SearchService,
  DocumentsService,
  LocalesService,
  UiAdminConfigsService,
  MsGraphService,
  ConfigurationService,
  AssignmentsService,
  TranslationsService,
  IndexesService,
  VersionsService
} from '@cs-cms/api-client';
import React from 'react';
import ServicesContext, { IServicesContext } from '../contexts/ServicesContext';

interface IServicesProviderProps {
  children: React.ReactNode;
}

const currentUserService = new CurrentUserService();
const viewsService = new ViewsService();
const fieldsService = new FieldsService();
const contentTypesService = new ContentTypesService();
const searchService = new SearchService();
const documentsService = new DocumentsService();
const localesService = new LocalesService();
const uiAdminConfigsService = new UiAdminConfigsService();
const msGraphService = new MsGraphService();
const configurationService = new ConfigurationService();
const assignmentsService = new AssignmentsService();
const translationsService = new TranslationsService();
const indexesService = new IndexesService();
const versionsService = new VersionsService();

const servicesContext: IServicesContext = {
  currentUserService,
  viewsService,
  fieldsService,
  contentTypesService,
  searchService,
  documentsService,
  localesService,
  uiAdminConfigsService,
  msGraphService,
  configurationService,
  assignmentsService,
  translationsService,
  indexesService,
  versionsService
};

export const ServicesProvider: React.FC<IServicesProviderProps> = props => {
  return <ServicesContext.Provider value={servicesContext}>{props.children}</ServicesContext.Provider>;
};
